module.exports = __webpack_public_path__ + "static/media/132.bf22203c.wav";